import {
  ChooseSingleTypeRefinementItem,
  DeleteSingleTypeRefinementItem,
} from "components/page-components/Internal-Search/utils"
import React, { useEffect } from "react"

import { FilterIcon } from "components/page-components/Icons/small"
import { connectRefinementList } from "react-instantsearch-dom"

export const TypeRefinement = connectRefinementList(
  ({
    items,
    refine,
    searchState,
    setSearchState,
    currentRefinement,
    set_focussed,
    search_modal_active,
    all_types,
  }) => {
    items = items.filter(({ label, count }) => !!label && !!count)

    const all_refinded = items.every(({ isRefined }) => !!isRefined)
    useEffect(() => {
      if (!searchState?.refinementList?.type) {
        refine(all_types)
      }
    }, [searchState?.refinementList?.type]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
      if (search_modal_active) {
        if (items.length > 2) {
          const all_item_types = {}
          items.map(({ label, count }) =>
            Object.assign(all_item_types, {
              [label]: count,
            })
          )
          sessionStorage.setItem(
            "internal_search_type_hitcount",
            JSON.stringify(all_item_types)
          )
        }
      }
    }, [items]) // eslint-disable-line react-hooks/exhaustive-deps

    const type_refinement_item_mapping = {
      "help-article": "Hilfe-Themen",
      author: "Autoren",
      blog: "Blog",
      event: "Veranstaltung",
      lexicon: "Lexikon",
      news: "News",
      notice: "Ausschreibungen",
      page: "Seiten",
      job_posting: "Jobs",
    }
    return (
      <div
        className="field is-grouped is-grouped-multiline-desktop"
        // style={{
        //   overflowX: "auto",
        // }}
      >
        <div className="control pt-1">
          <FilterIcon {...{ color: "#FFFFFF", size: 0.9 }} />
        </div>
        {items?.map(({ isRefined, label, count }) => {
          return (
            <div className="control" key={`type_refinement-${label}`}>
              <div className="tags has-addons is-clickable internal-search-type-tags are-medium">
                <ChooseSingleTypeRefinementItem
                  {...{
                    count,
                    searchState,
                    setSearchState,
                    set_focussed,
                    all_refinded,
                    isRefined: isRefined && !all_refinded,
                    is_deleted: !currentRefinement.some(
                      (item) => item === label
                    ),
                    type_name: label,
                    text: type_refinement_item_mapping[label],
                    refine,
                  }}
                />
                <DeleteSingleTypeRefinementItem
                  {...{
                    type_name: label,
                    all_types,
                    refine,
                    currentRefinement,
                    is_deleted: !currentRefinement.some(
                      (item) => item === label
                    ),
                    isRefined: isRefined && !all_refinded,
                  }}
                />
              </div>
            </div>
          )
        })}
      </div>
    )
  }
)
